var exports = {
  "k": "x4ddf2309--e14d4d--container",
};

module.exports = exports;
